import * as type from '../../types';

const initialLoginState = {
  response: {},
  loading: false,
  error: null
}
const initialUserState = {
  response: {},
  loading: false,
  error: null
}
const initialSignupState = {
  response: {},
  loading: false,
  error: null
}


export function loginReducer(state = initialLoginState, action) {
  switch (action.type) {
    case type.FETCH_LOGIN:
      return { ...state, loading: true };

    case type.FETCH_LOGIN_SUCCESS:
      localStorage.setItem("loginResponse", JSON.stringify(action.data.data));
      return {
        ...state,
        loading: false,
        response: action.data.data
      };

    case type.FETCH_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          message: action.message,
          status: action.status
        }
      };

    case type.FETCH_LOGIN_CLEAR:
      localStorage.removeItem("loginResponse"); // clear on logout
      return {
        ...state,
        loading: false,
        response: {}
      };

    default:
      return state;
  }
}

export function userReducer(state = initialUserState, action) {
  switch (action.type) {
    case type.SET_USER:
      return {
        ...state,
        loading: false,
        response: action.data
      }
    default:
      return state
  }
}

export function signupReducer(state = initialSignupState, action) {
  switch (action.type) {
    case type.FETCH_SIGNUP_REQUEST:
      return { ...state, loading: true };

    case type.FETCH_SIGNUP_SUCCESS:
      localStorage.setItem("signupResponse", JSON.stringify(action.response));
      return {
        ...state,
        loading: false,
        response: action.response
      };

    case type.FETCH_SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          message: action.message,
          status: action.status
        }
      }

    case type.FETCH_SIGNUP_CLEAR:
      localStorage.removeItem("signupResponse"); // clear on logout
      return {
        ...state,
        loading: false,
        response: {}
      };

    default:
      return state;
  }
}